import { Component, EventEmitter, Inject, LOCALE_ID, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PersonalCodeValidator } from '@ridango/core';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-login-smartid-form',
    templateUrl: './login-smartid-form.component.html',
    styleUrls: ['./login-smartid-form.component.scss']
})
export class LoginSmartidFormComponent implements OnInit {
    loginForm: FormGroup;

    @Output() onLogin = new EventEmitter<any>();

    constructor(
        @Inject('ENV') public env: Env,
        @Inject(LOCALE_ID) public locale: string,
        private personalCodeValidator: PersonalCodeValidator
    ) {}

    ngOnInit(): void {
        if (this.locale.length !== 2) {
            this.locale = 'en';
        }

        this.loginForm = new FormGroup({
            personalCode: new FormControl('', [Validators.required, this.personalCodeValidator.getValidator()])
        });
    }

    login() {
        if (this.loginForm.valid) {
            this.onLogin.emit(this.loginForm.value);
        } else {
            this.personalCode.markAsTouched();
        }
    }

    get personalCode() {
        return this.loginForm.get('personalCode');
    }
}
